import React from 'react';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

const HeroNew = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="inicio"
      className="relative min-h-[600px] lg:min-h-[700px] flex items-center overflow-hidden pt-24 pb-12"
      style={{
        background:
          'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 45%, #d1d5db 100%)',
      }}
    >
      {/* Subtle dot grid - right side */}
      <div className="absolute right-[35%] top-1/2 transform -translate-y-1/2 opacity-30 hidden lg:block">
        <div className="grid grid-cols-4 gap-3">
          {[...Array(16)].map((_, i) => (
            <div key={i} className="w-2 h-2 rounded-full bg-gray-400" />
          ))}
        </div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          {/* LEFT SIDE - Mascot + Logo + Text */}
          <div className="flex flex-col space-y-4 relative">
            {/* Mascot - top of column on the left */}
            <img
              src="https://customer-assets.emergentagent.com/job_power-equipment/artifacts/i0ha3e5j_LOGO%20GENSOL%20SIN%20FONDO.png"
              alt="GENSOL Mascot"
              className="w-32 sm:w-40 md:w-48 h-auto drop-shadow-xl -mb-2 relative z-10"
            />

            {/* Main Headline */}
            <div>
              <h1
                className="text-6xl sm:text-7xl md:text-8xl lg:text-9xl font-black text-[#FF6600] leading-none tracking-tight"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                GENSOL
              </h1>
              <h2
                className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-black mt-2 leading-tight"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Energía para llevar
              </h2>
            </div>

            {/* Description removed - shown in H1 SEO section below to avoid duplication */}

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={scrollToContact}
                data-testid="hero-cta-cotizacion"
                className="bg-[#FF6600] hover:bg-[#FF8C00] text-white text-base md:text-lg px-6 md:px-8 py-5 md:py-6 rounded-lg shadow-lg transition-all duration-300 hover:scale-105"
              >
                Solicitar Cotización
                <ArrowRight className="ml-2 w-5 h-5" />
              </Button>
              <a
                href="https://wa.me/522292072733?text=Hola%2C%20me%20interesa%20rentar%20equipo%20GENSOL"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="hero-whatsapp-link"
              >
                <Button
                  variant="outline"
                  className="border-2 border-[#FF6600] text-[#FF6600] hover:bg-[#FF6600] hover:text-white text-base md:text-lg px-6 md:px-8 py-5 md:py-6 rounded-lg transition-all duration-300 hover:scale-105 w-full sm:w-auto bg-white/60 backdrop-blur-sm"
                >
                  <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                  WhatsApp
                </Button>
              </a>
            </div>
          </div>

          {/* RIGHT SIDE - Diamond Photo Frames and Multimeter */}
          <div className="relative h-[400px] lg:h-[550px] hidden lg:flex items-center justify-center">
            {/* Diamond Frame 1 - Top Right */}
            <div className="absolute top-0 right-0 w-64 h-64 xl:w-72 xl:h-72">
              <div className="w-full h-full transform rotate-45 overflow-hidden border-[6px] border-[#FF6600] shadow-2xl bg-white">
                <img
                  src="https://customer-assets.emergentagent.com/job_power-equipment/artifacts/d275u8zu_WhatsApp%20Image%202025-11-15%20at%209.03.37%20AM.jpeg"
                  alt="Generador GENSOL - Equipo de renta"
                  className="w-full h-full object-cover transform -rotate-45 scale-[1.5] origin-center"
                />
              </div>
            </div>

            {/* Diamond Frame 2 - Middle */}
            <div className="absolute top-40 xl:top-48 right-44 xl:right-52 w-56 h-56 xl:w-64 xl:h-64">
              <div className="w-full h-full transform rotate-45 overflow-hidden border-[6px] border-[#FF6600] shadow-2xl bg-white">
                <img
                  src="https://customer-assets.emergentagent.com/job_power-equipment/artifacts/ca8jb2mq_WhatsApp%20Image%202025-11-26%20at%202.20.17%20PM%20%285%29.jpeg"
                  alt="Camioneta GENSOL con generador"
                  className="w-full h-full object-cover transform -rotate-45 scale-[1.5] origin-center"
                />
              </div>
            </div>

            {/* Dot grid - between frames */}
            <div className="absolute top-32 right-32 opacity-50 z-10">
              <div className="grid grid-cols-4 gap-2">
                {[...Array(16)].map((_, i) => (
                  <div key={i} className="w-1.5 h-1.5 rounded-full bg-gray-500" />
                ))}
              </div>
            </div>

            {/* Multimeter - Bottom Right */}
            <div className="absolute -bottom-8 right-0 xl:-bottom-4 xl:right-4 z-20">
              <img
                src="https://customer-assets.emergentagent.com/job_44da33e2-9df0-4e2d-82b0-9d3a733fa63e/artifacts/l184rfce_Untitled%20design%20%285%29.png"
                alt="Multímetro digital profesional"
                className="w-80 h-auto xl:w-96 drop-shadow-2xl"
              />
            </div>
          </div>
        </div>
      </div>

      {/* Mobile decoration */}
      <div className="lg:hidden absolute bottom-4 right-4 opacity-30">
        <div className="w-16 h-16 border-4 border-[#FF6600] transform rotate-45"></div>
      </div>
    </section>
  );
};

export default HeroNew;
